"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.backfillDesignVersions = backfillDesignVersions;
const path = __importStar(require("path"));
const createPlan_1 = require("./createPlan");
/** Collect every `*.md` directly inside a `plans/` directory under `dir`. */
async function walkPlanFiles(dir, fs) {
    const out = [];
    const entries = await fs.readdir(dir).catch(() => []);
    for (const name of entries) {
        if (name === '.archive' || name === 'node_modules' || name === '.git')
            continue;
        const full = path.join(dir, name);
        const st = await fs.stat(full).catch(() => null);
        if (!st)
            continue;
        if (st.isDirectory()) {
            out.push(...(await walkPlanFiles(full, fs)));
        }
        else if (name.endsWith('.md') && path.basename(dir) === 'plans') {
            out.push(full);
        }
    }
    return out;
}
async function backfillDesignVersions(opts, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const docsDir = path.join(loomRoot, 'loom');
    const dryRun = !!opts.dryRun;
    const changed = [];
    const failed = [];
    let scanned = 0;
    if (!(await deps.fs.pathExists(docsDir)))
        return { changed, scanned, failed, dryRun };
    const files = await walkPlanFiles(docsDir, deps.fs);
    for (const file of files) {
        scanned++;
        try {
            // Plan path is `.../loom/{weave}/{thread}/plans/{file}.md`; the thread dir is
            // two levels up and its basename is the threadSlug the design is named after.
            const threadDir = path.dirname(path.dirname(file));
            const threadSlug = path.basename(threadDir);
            const design = await (0, createPlan_1.parentDesignVersion)(threadDir, threadSlug, { loadDoc: deps.loadDoc, fs: deps.fs });
            if (!design)
                continue; // weave-root / design-less plan: no baseline to repair
            const doc = (await deps.loadDoc(file));
            if (doc.type !== 'plan')
                continue;
            if (doc.design_version === design.version)
                continue; // already correct
            changed.push({ path: path.relative(loomRoot, file), from: doc.design_version, to: design.version });
            if (!dryRun) {
                doc.design_version = design.version;
                await deps.saveDoc(doc, file);
            }
        }
        catch (e) {
            failed.push({ path: path.relative(loomRoot, file), error: e?.message ?? String(e) });
        }
    }
    return { changed, scanned, failed, dryRun };
}
